export const styles = {
  formContainer: 'tw-space-y-6',
  connectivityWrapper: 'tw-pt-2',
};
